import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import Tab from 'portaltransparencia-common/components/Tab.react.js';
import Tabs from 'portaltransparencia-common/components/Tabs.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import { downloadArquivo } from '../arquivo/Actions.js';
import PageHeader from '../components/PageHeader.react.js';
import * as actions from './Actions.js';
import IntencaoRegistroPrecoAnexos from './IntencaoRegistroPrecoAnexos.react.js';
import IntencaoRegistroPrecoItens from './IntencaoRegistroPrecoItens.react.js';

export class IntencaoRegistroPrecoDetalhe extends Component {
  static propTypes = {
    irp: PropTypes.object.isRequired,
    itens: PropTypes.object.isRequired,
    arquivos: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    findIrp: PropTypes.func.isRequired,
    findItens: PropTypes.func.isRequired,
    findArquivos: PropTypes.func.isRequired,
    downloadArquivo: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.findIrp(id);
    this.props.findItens(id);
    this.props.findArquivos(id);
  }

  render() {
    const { irp, itens, arquivos, location, downloadArquivo } = this.props;
    const identificacao = irp.get('numero')
      ? `${irp.get('numero')}/${irp.get('ano')}`
      : '';

    return (
      <section>
        <Helmet
          id="helmet"
          title={`IRP - Intenção de Registro de Preço${
            identificacao ? ` - ${identificacao}` : ''
          }`}
        />
        <PageHeader
          location={location}
          textoDetalhe={`IRP - Intenção de Registro de Preço${
            identificacao ? `: ${identificacao}` : ''
          }`}
        />

        <Panel title="Detalhes da Intenção de Registro de Preço">
          <DisplayData border column>
            <DisplayDataRow>
              <DisplayDataItem
                sm={3}
                title="Número/Ano"
                value={identificacao}
                id="numeroAno"
              />
              <DisplayDataItem
                sm={4}
                title="Modalidade"
                value={irp.get('modalidadeDescricao')}
                id="modalidadeDescricao"
              />
              <DisplayDataItem
                sm={5}
                title="Data Final de Manifestação de Interesse"
                value={DateUtils.formatDateTime(
                  irp.get('dataFimInteresse'),
                  'DD/MM/YYYY HH:mm'
                )}
                id="dataFimInteresse"
              />
            </DisplayDataRow>
            <DisplayDataRow>
              <DisplayDataItem
                sm={4}
                title="Instrumento Convocatório"
                value={irp.get('instrumentoConvocatorioDescricao')}
                id="instrumentoConvocatorioDescricao"
              />
              <DisplayDataItem
                sm={5}
                title="Amparo Legal"
                value={irp.get('amparoLegalDescricao')}
                id="amparoLegalDescricao"
              />
              <DisplayDataItem
                sm={3}
                title="Modo de Disputa"
                value={irp.get('modoDisputaDescricao')}
                id="modoDisputaDescricao"
              />
            </DisplayDataRow>
            <DisplayDataRow>
              <DisplayDataItem
                sm={12}
                title="Objeto"
                value={irp.get('objeto')}
                id="objeto"
              />
            </DisplayDataRow>
            <DisplayDataRow>
              <DisplayDataItem
                sm={9}
                title="Complemento"
                value={irp.get('complemento')}
                id="complemento"
              />
              <DisplayDataItem
                sm={3}
                title="Possibilita Adesão"
                value={irp.get('adesao') ? 'Sim' : 'Não'}
                id="adesao"
              />
            </DisplayDataRow>
          </DisplayData>

          <hr className="mt-xs mb-xs" />

          <Tabs id="tabs-irp">
            <Tab title="Itens" onlyTable tableResponsive active={true}>
              <IntencaoRegistroPrecoItens itens={itens} />
            </Tab>
            <Tab title="Anexos" onlyTable tableResponsive>
              <IntencaoRegistroPrecoAnexos
                arquivos={arquivos}
                onDownload={downloadArquivo}
              />
            </Tab>
          </Tabs>
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    irp: state.irp.get('irp'),
    itens: state.irp.get('itens'),
    arquivos: state.irp.get('arquivos')
  };
}

const allActions = {
  ...actions,
  downloadArquivo
};

export default connect(
  mapStateToProps,
  allActions
)(IntencaoRegistroPrecoDetalhe);
